import { types } from 'mobx-state-tree';
import { Statistics } from '../../models/Discover';
import Detail from './Detail';

const QCard = types
  .model('QCard', {
    accountCode: types.maybe(types.string),
    details: types.maybe(types.array(Detail)),
    discoveryMethod: types.maybe(types.number),
    errorMessage: types.maybe(types.string),
    id: types.maybe(types.number),
    isOnListingProgress: types.maybe(types.boolean),
    processedItemsCount: types.maybe(types.number),
    sourceMarketplaceId: types.maybe(types.number),
    itemsListed: types.maybe(types.number),
    itemsFailed: types.maybe(types.number),
    statistics: types.maybe(Statistics),
    time: types.maybe(types.number),
    totalItemsCount: types.maybe(types.number),
    typeId: types.maybe(types.number),
    automaticallyListItems: types.maybe(types.boolean),
    storeName: types.maybe(types.string),
  })
  .actions(self => ({
    setItems(items) {
      self.processedItemsCount = items;
    },
  }));

export default QCard;
